module.exports = __webpack_public_path__ + "media/images/girl-sitting-laptop-3072149de51dfa5059737569e000a25c.svg";